export enum ContextComponents {
    PARAGRAPH = 'paragraph',
    TABLE = 'table',
    KIT = 'kit',
    BLOWUP = 'blowup'
}
